import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/icon/style";
import _Icon from "antd/lib/icon";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty"; /*@客户-日流量*/
import React from 'react';
import './index.scss';
import HeaderBar from "../../Common/HeaderBar";
import HistoryFlowModal from "./subComponents/HistoryFlowModal";
import { parse } from "../../../utils/commonUtilFunc";
import BossTable from "../../Common/BossTable";
import moment from "moment";
import { injectIntl } from 'react-intl';
import BossHeaderChoose from "../../Common/BossHeaderChoose";
var CI0401 = /*#__PURE__*/function (_React$Component) {
  _inherits(CI0401, _React$Component);
  function CI0401(props) {
    var _this;
    _classCallCheck(this, CI0401);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CI0401).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInit", function () {
      _this.props.dispatch({
        type: "ci0401Info/init",
        payload: {
          company_id: _this.state.company_id,
          name: _this.state.name
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkRate", function (record) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        ifModalShow: true,
        link_id: record.id,
        deduplication: record.deduplication
      }, function () {
        vm.props.dispatch({
          type: "ci0401Info/getHistoryRate",
          payload: {
            link_id: record.id,
            start_time: moment().subtract(7, "days").format("YYYY-MM-DD"),
            end_time: moment().format("YYYY-MM-DD")
          }
        });
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelCheckRate", function () {
      _this.setState({
        ifModalShow: false,
        link_id: "",
        deduplication: ""
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "searchTopo", function (value) {
      _this.setState({
        name: value
      }, function () {
        _this.getInit();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchCompany", function (value) {
      _this.setState({
        company_id: value
      }, function () {
        this.getInit();
      });
    });
    _this.state = {
      ifModalShow: false,
      startTime: undefined,
      endTime: undefined,
      topo_id: "",
      name: "",
      deduplication: "",
      company_id: parse(_this.props.location.search).id ? parse(_this.props.location.search).id : sessionStorage.getItem('companyId')
    };
    _this.isCustom = sessionStorage.getItem("role") === "companystaff" || sessionStorage.getItem("role") === 'company';
    _this.isJSZC = sessionStorage.getItem("role") === "supercxptechsupport" || sessionStorage.getItem("role") === "supercxptechadmin";
    return _this;
  }
  _createClass(CI0401, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isCustom) {
        this.getInit();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var columns = [{
        title: "Link Name",
        dataIndex: 'name',
        key: 'name'
      }, {
        title: "Raw data traffic (MB)",
        dataIndex: 'origin',
        key: 'origin',
        render: function render(index, record) {
          return /*#__PURE__*/React.createElement("span", null, (record.origin / 1024 / 1024).toFixed(2));
        }
      }, {
        title: "Weight removal rate (%)",
        dataIndex: 'dedup_percent',
        key: 'dedup_percent',
        render: function render(index, record) {
          return record.dedup !== 0 ? /*#__PURE__*/React.createElement("span", null, (100 * (record.dedup_raw - record.dedup) / record.dedup_raw).toFixed(2)) : /*#__PURE__*/React.createElement("span", null, "0");
        }
      }, {
        title: "Compression rate (%)",
        dataIndex: 'compress_percent',
        key: 'compress_percent',
        render: function render(index, record) {
          return record.rate !== 0 ? /*#__PURE__*/React.createElement("span", null, (100 * (record.rate - record.drate) / record.rate).toFixed(2)) : /*#__PURE__*/React.createElement("span", null, "0");
        }
      }, {
        title: "Historical traffic",
        dataIndex: 'company_name',
        key: 'company_name',
        width: 100,
        align: "center",
        render: function render(index, record) {
          return /*#__PURE__*/React.createElement(_Icon, {
            onClick: function onClick() {
              return _this2.checkRate(record);
            },
            type: "line-chart",
            style: {
              color: "#3b96ff"
            }
          });
        }
      }];
      var pagination = {
        pageSize: 10
      };
      return /*#__PURE__*/React.createElement("div", null, !this.isCustom ? /*#__PURE__*/React.createElement(BossHeaderChoose, {
        onChange: this.handleSearchCompany
      }) : '', /*#__PURE__*/React.createElement(_Card, {
        className: "card"
      }, /*#__PURE__*/React.createElement(HeaderBar, {
        hasSearch: true,
        hasDelete: false,
        submit: this.searchTopo
      }), /*#__PURE__*/React.createElement(BossTable, {
        pagination: pagination,
        columns: columns,
        dataSource: this.props.ci0401Info.dataSource
      }), this.state.ifModalShow ? /*#__PURE__*/React.createElement(HistoryFlowModal, {
        link_id: this.state.link_id,
        ifModalShow: this.state.ifModalShow,
        cancel: this.cancelCheckRate,
        deduplication: this.state.deduplication,
        destroyOnClose: true
      }) : ''));
    }
  }]);
  return CI0401;
}(React.Component);
export default injectIntl(CI0401);